var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container", attrs: { id: "goods-edit" } }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("商品管理")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("运费模板")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "content" }, [
      _c("h2", [_vm._v("运费模板")]),
      _c(
        "div",
        [
          _c(
            "el-form",
            { attrs: { inline: true, size: "small", "label-width": "110px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模板名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入模板名称" },
                    model: {
                      value: _vm.name,
                      callback: function ($$v) {
                        _vm.name = $$v
                      },
                      expression: "name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticStyle: { "padding-bottom": "10px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.getList("search")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.getList("reset")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "space-between" },
        },
        [
          _c("h3", { staticStyle: { width: "100%" } }, [_vm._v("列表数据")]),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.add("add")
                    },
                  },
                },
                [_vm._v("新增模板")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticStyle: { "padding-bottom": "20px", "margin-top": "16px" } },
        _vm._l(_vm.models, function (item, index) {
          return _c(
            "el-card",
            {
              key: index,
              staticClass: "box-card",
              staticStyle: { "margin-bottom": "20px" },
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [_vm._v(_vm._s(item.name))]),
                _c(
                  "span",
                  {
                    staticStyle: { "font-size": "14px", "margin-left": "20px" },
                  },
                  [_vm._v("最后编辑时间：" + _vm._s(item.updatedTime))]
                ),
                item.isSync == 1
                  ? _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "margin-left": "20px",
                        },
                      },
                      [_vm._v("同步模板")]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticStyle: { float: "right" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.copyModel(item)
                          },
                        },
                      },
                      [_vm._v("复制模板")]
                    ),
                    _c("span", {
                      staticStyle: {
                        "font-size": "14px",
                        color: "#409eff",
                        "margin-left": "10px",
                        "margin-right": "10px",
                      },
                    }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.add("edit", item.id)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c("span", {
                      staticStyle: {
                        "font-size": "14px",
                        color: "#409eff",
                        "margin-left": "10px",
                        "margin-right": "10px",
                      },
                    }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteModel(item)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: item.list,
                        border: "",
                        "header-cell-style": {
                          "text-align": "center",
                          background: "#F8F8F9",
                        },
                        "cell-style": { "text-align": "center" },
                      },
                    },
                    [
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            prop: "date",
                            label: "运送方式",
                            width: "180",
                          },
                        },
                        [[_vm._v(" 快递 ")]],
                        2
                      ),
                      _c("el-table-column", {
                        attrs: { prop: "betterAddress", label: "运送到" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.address == "全部地区"
                                    ? _c("div", [_vm._v("全部地区")])
                                    : _c(
                                        "div",
                                        [
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                "popper-class": "atooltip",
                                                effect: "dark",
                                                content: scope.row.address,
                                                placement: "bottom-start",
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _vm._v("地区（查看区域）"),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c(
                        "el-table-column",
                        { attrs: { prop: "firstNum", label: "首件（个）" } },
                        [
                          _c("template", { slot: "header" }, [
                            item.list && item.list[0].calculType == 2
                              ? _c(
                                  "div",
                                  { staticStyle: { "text-align": "center" } },
                                  [_vm._v(" 首重（KG） ")]
                                )
                              : _c(
                                  "div",
                                  { staticStyle: { "text-align": "center" } },
                                  [_vm._v("首件（个）")]
                                ),
                          ]),
                        ],
                        2
                      ),
                      _c("el-table-column", {
                        attrs: { prop: "freight", label: "运费（元）" },
                      }),
                      _c(
                        "el-table-column",
                        { attrs: { prop: "addNum", label: "续件（个）" } },
                        [
                          _c("template", { slot: "header" }, [
                            item.list && item.list[0].calculType == 2
                              ? _c(
                                  "div",
                                  { staticStyle: { "text-align": "center" } },
                                  [_vm._v(" 续重（KG） ")]
                                )
                              : _c(
                                  "div",
                                  { staticStyle: { "text-align": "center" } },
                                  [_vm._v("续件（个）")]
                                ),
                          ]),
                        ],
                        2
                      ),
                      _c("el-table-column", {
                        attrs: { prop: "addPrice", label: "运费（元）" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        }),
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }